import { useTranslation } from "react-i18next";
import "../styles/main.css";
import "../styles/hover.css";
import "animate.css";

const HeroComponent = () => {
  const { t } = useTranslation();

  return (
    <section id="hero-section">
      <div className="animate__animated animate__fadeIn text-center hero-section-elements">
        <h2 className="page-not-found-title hvr-wobble-vertical">
          {t('hero.title')}
        </h2>
      </div>
    </section>
  );
};

export default HeroComponent;
